export enum ApprovementStatus {
  Draft = 1,
  SentToApproval = 2,
  Rejected = 3,
  ApprovedFirstLevel = 4,
  ApprovedSecondLevel = 5,
  SentToDelete = 6,
  DeletedFirstLevel = 7,
  DeletedSecondLevel = 8,
  DeletedPermanently = 9,
}
